/**
 * Navigators
 */
export { default as createMaterialTopTabNavigator } from './navigators/createMaterialTopTabNavigator';

/**
 * Views
 */
export { default as MaterialTopTabView } from './views/MaterialTopTabView';
export { default as MaterialTopTabBar } from './views/MaterialTopTabBar';

/**
 * Types
 */
export {
  MaterialTopTabNavigationOptions,
  MaterialTopTabNavigationProp,
  MaterialTopTabBarProps,
  MaterialTopTabBarOptions,
} from './types';
